import React from "react";
import profile from "../../images/my-photo.png";
import "./Banner.css";
import CV from "../../CV/NAZMUL_FULL-STACK_DEVELOPER__RESUME.pdf";
import { BsDot } from "react-icons/bs";
import {
  FaFacebookF,
  FaInstagram,
  FaTwitter,
  FaLinkedinIn,
  FaRedditAlien,
  FaGithub,
} from "react-icons/fa";

const Banner = () => {
  return (
    <section id="home">
      <div className="banner-part full-screen py-5 primary-bg">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-7">
              <div className="name-title">
                <h2>Hello! I'm </h2>
                <h2 className="my-name">
                  <span className="bold">Nazmul Hasan Nannu</span>
                </h2>
                {/* <Typed
                  strings={["Designer", "Developer"]}
                  typeSpeed={40}
                  backSpeed={50}
                  loop
                  className="my-title"
                /> */}
                <h1 className="my-title">Full Stack Developer</h1>
                <div className="pro">
                  <ul>
                    <li>Programmer</li>
                    <li>
                      <span className="dot-sep">
                        <BsDot size={32} />
                      </span>
                      Web Developer
                    </li>
                    <li>
                      <span className="dot-sep">
                        <BsDot size={32} />
                      </span>
                      App Developer
                    </li>
                  </ul>
                </div>
                <div className="profolio-links">
                  <ul className="profolio-link">
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://github.com/nannu-coder"
                      >
                        <FaGithub size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.facebook.com/nannu.hasan.32/"
                      >
                        <FaFacebookF size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.instagram.com/nazmul_nannu/"
                      >
                        <FaInstagram size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.linkedin.com/in/nazmulnannu/"
                      >
                        <FaLinkedinIn size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://twitter.com/NannuHasan32"
                      >
                        <FaTwitter size={22} />
                      </a>
                    </li>
                    <li>
                      <a
                        rel="noreferrer"
                        target="_blank"
                        href="https://www.reddit.com/user/nazmul_nannu"
                      >
                        <FaRedditAlien size={22} />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div id="banner-btn" className="banner-btn mt-4 d-inline-block">
                <a className="get-resume" href={CV} download="resume.pdf">
                  <button id="work-btn" className="work-btn me-5">
                    Get Resume
                  </button>
                </a>
                <a href="#skill">
                  <button className="my-skill">My Skills</button>
                </a>
              </div>
            </div>
            <div className="col-lg-5 res-banner">
              <div
                id="banner-img-container"
                className="bg-light p-3 shadow-md d-inline-block banner-img-container"
              >
                <img
                  className="img-fluid d-block banner-image"
                  src={profile}
                  alt="my-pic"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Banner;
